let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bSqLh")).then(() => parcelRequire('8brzZ'));